import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
  RequestData, ResponseData
} from '../../../../core/models/common';
import { ApiService } from '../../../../core/services/api-mock.service';
import { AppUtilityService } from '../../../../core/services/app-utility.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SmsOtpVerificationComponent } from '../../components/sms-otp-verification/sms-otp-verification.component';
import { Subscription } from 'rxjs';
import { SharedAPIService } from '../../../../core/services/shared-api.service';
import { BasicModalComponent } from '../../../fna/components/basic-modal/basic-modal.component';
import {
  ChangePasswordComponent,
  ChangePasswordRequestData,
} from '../../components/change-password/change-password.component';
import {
  ForgotPasswordComponent,
  
} from '../../components/forgot-password/forgot-password.component';
import { share } from 'rxjs/operators';
//import * as crypto from 'crypto'

// What we receive from the API, and we will send to the API.

export interface RequestServiceBodyGetOTP  {
  EmailAddress?: string;
  Password?: string;
  AuthCode?: string;
  LoginMethod?: string;
}



export interface ResponseServiceBodyGetOTP  {
  OTPDelayTime: string
}

export interface LoginSMSOTPRequestData extends PostRequestBase {
  ServiceBody : any
}
export interface RequestServiceBodyValidateOTP  {
  OTPCode : string
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  changePasswordModal: NgbModalRef | undefined;
  smsOtpModal: NgbModalRef | undefined;
  forgotPasswordModal: NgbModalRef | undefined;
  changePasswordSubmitSubscription: Subscription | null = null;
  isLoginFormSubmitted: boolean = false;
  isLoginFailed: boolean = false;
  otpSubmitSubscription: Subscription | null = null;
  otpResendSubscription: Subscription | null = null;
  forgotPasswordSubscription: Subscription | null = null;

  pageName: String  = 'login';
  pageID_getStaticData = 'R0000';
  pageID_getOTPTimeout = 'R0010';
  pageID_validateOTP = 'R0011';
  pageID_resendOTP = 'R0012'
  pageID_productDetails = 'R0080';
  pageID_forgotPassword = 'R0013';

  lastSavedUIPage = "";
  
  bv_login_URL:String = '' ;
  bv_login_clientID:String = '' ;
  servlet_context_path:String = '';
  bv_action:String  = '';

  login_fail_message = "Login Failed"

  loginForm: FormGroup = this.formBuilder.group({
    emailAddress: ['', [Validators.required, Validators.email]],
    password: [
      '',
      [Validators.required, Validators.minLength(8), Validators.maxLength(12)],
    ],
    caseID :['', [Validators.required]]
  });
  loginFormBV: FormGroup = this.formBuilder.group({
    
    caseID :['', [Validators.required]]
  });

  constructor(
    public globals: GlobalsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private apiService: ApiService,
    private appUtility: AppUtilityService,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService
  ) {}

  async ngOnInit() {
    console.log("AUTO DEPLOYMENT TEST 5/1/2022")
    
    const authCode =  window.localStorage.getItem('digital-fna-bvlogin-code')
    const redirectFromDocusign = window.localStorage.getItem('digital-fna-redirect-from-docusign')
   //const refreshLink = window.localStorage.getItem('refresh-link')

  //  if(refreshLink && refreshLink!=undefined && refreshLink != ""){
  //   window.localStorage.setItem('refresh-link','');
  //   this.router.navigateByUrl('/'+refreshLink);
  //  }
   if(redirectFromDocusign && redirectFromDocusign!='null' ){
    //window.localStorage.setItem('digital-fna-redirect-from-docusign','');
    this.router.navigateByUrl('/fna/review-and-submit');
   }else if(authCode && authCode!='null' && authCode!='Null' && this.sharedAPIService.getRedirectionType() == "from_BV"){
     //get code from url
    this.sharedAPIService.setRedirectionType('');
    await this.verifyOtherLogin(authCode,'BV')
   }else{
    console.log('LoginComponent.ngOnInit');
    const model = new ScreenModel(this.globals, this.apiService, this.el);
    await this.getStaticDataService();
    this.getCorpPassDetailsService();
    
   }
   
  }


  getPasswordHash(plainText:string){

    console.log('Cryptoooo')
    let sha= require('js-sha512')
    let hash = sha.create().update(plainText).hex();

    console.log(hash)

    return hash
  }

  async verifyOtherLogin(authCode:string,method:string){
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = 'Login';

     const serviceBody:RequestServiceBodyGetOTP = {
      AuthCode : authCode,
      LoginMethod : method
    }
    // Call API to submit OTP & token
    const data: RequestData = Object.assign(
      screenModel.getDefaultPostRequest(),
      {
        ServiceBody :serviceBody
      },
    );
    const newData :RequestData = Object.assign({},data,{ServiceHeader : {
      ...data.ServiceHeader,
      PageName : this.pageName,
      RequestID : this.pageID_getOTPTimeout
    }})
  //   this.sharedAPIService.getOTPTimeOut(newData).subscribe((response: any) => {

  //     console.log("suTABtest");
  //     console.log(response);
   

  // })
    console.log(newData)
    const {Errors:errors, ServiceBody :serviceBodyRes,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } =
    await this.apiService.read(newData);

    // On Success, return maskedMobileNumber & token/id/identifier(?)
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {

      if(serviceBodyRes && serviceBodyRes['LastLoginDateTime'] && serviceBodyRes['LastLoginDateTime']!=''){
        this.globals.updateModel({LastLoginTime: serviceBodyRes['LastLoginDateTime']})
      }
     
      localStorage.setItem('DFNA-tokenID',responseServiceHeader['TokenID'])
      let lastSavedPage = serviceBodyRes['LastSavedUIPage']
      //redirect to 
      const routeUrl: { [key: string]: string } = {
        AccreditedInvestor: '/fna/accredited-investor',
        AccreditedInvestorOptIn: '/fna/accredited-investor-application',
        AccreditedInvestorConfirm: '/fna/accredited-investor-confirmation',
        FinancialSituation: '/fna/financial-situation',
        NonRecommendedProducts: '/fna/non-recommended-products',
        OrganizationInformation: '/fna/organisation-information',
        RecommendedProducts: '/fna/recommended-products',
        ReviewAndSubmit: '/fna/review-and-submit',
        RiskAndObjectives: '/fna/risk-and-objectives',
        RiskProfileAssessment: '/fna/risk-profile-assessment',
        Confirmation: '/fna/confirmation',
      }

      if (serviceBodyRes && serviceBodyRes['LastSavedUIPage'] && serviceBodyRes['LastSavedUIPage']!='') { //condition for last page opened
        //this.router.navigateByUrl(routeUrl[serviceBodyRes['LastSavedUIPage']]);
        this.router.navigateByUrl(this.getRouteToURL(serviceBodyRes['LastSavedUIPage']));
        //this.router.navigateByUrl('/fna/accredited-investor');
      } else {
        this.router.navigateByUrl('/fna/accredited-investor');
      }
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }
  }

  getRouteToURL(LastSavedUIPage:string){
    if(LastSavedUIPage.includes('Confirmation')){
      let ConfirmationPageState = LastSavedUIPage.split('|')[1];
      this.sharedAPIService.setDocusignStatus(ConfirmationPageState);
      LastSavedUIPage = LastSavedUIPage.split('|')[0];
    }

    const routeUrl: { [key: string]: string } = {
      AccreditedInvestor: '/fna/accredited-investor',
      AccreditedInvestorOptIn: '/fna/accredited-investor-application',
      AccreditedInvestorConfirm: '/fna/accredited-investor-confirmation',
      FinancialSituation: '/fna/financial-situation',
      NonRecommendedProducts: '/fna/non-recommended-products',
      OrganizationInformation: '/fna/organisation-information',
      RecommendedProducts: '/fna/recommended-products',
      ReviewAndSubmit: '/fna/review-and-submit',
      RiskAndObjectives: '/fna/risk-and-objectives',
      RiskProfileAssessment: '/fna/risk-profile-assessment',
      Confirmation: '/fna/confirmation',
    };

    return routeUrl[LastSavedUIPage]
  }
  async getBVDetailsService(){
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = "login"
    const response = await screenModel.callBVDetailsService();

    this.bv_login_clientID= response.ClientID;
    this.bv_login_URL = response.RedirectURL;
    this.servlet_context_path = response.ServletContextPath;
    this.bv_action = response.Action;
    this.sharedAPIService.setServletContextPath(this.servlet_context_path+"")
   
  }
  async getStaticDataService(){
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = "login"
    const response = await screenModel.callStaticDataService(this.pageID_getStaticData,{});
    
    if(response){
      const { TermsandConditions: termsandConditions, CurrencyData: currencyData,DocumentRisk:documentRisk, DocumentPurpose:documentPurpose, DocumentNotice:documentNotice ,FrequencyData : frequencyData}  = response
      this.sharedAPIService.setCurrencyData(currencyData)
      this.sharedAPIService.setDocumentPurpose(documentPurpose);
      this.sharedAPIService.setDocumentRisk(documentRisk);
      this.sharedAPIService.setDocumentNotice(documentNotice);
      this.sharedAPIService.setTermsAndConditions(termsandConditions);
      this.sharedAPIService.setFrequencyData(frequencyData);
    }
   
    //console.log(this.sharedAPIService.getTermsAndConditions())
  }

  getCorpPassDetailsService(){
    this.sharedAPIService.getCorpPassAtt({}).subscribe((response: any) => {

        console.log("success");
        console.log(response);
     

    })
  }

  ngOnDestroy() {
    console.log('LoginComponent.ngOnDestroy');
    this.otpSubmitSubscription?.unsubscribe();
    this.otpResendSubscription?.unsubscribe();
    this.changePasswordSubmitSubscription?.unsubscribe();
    this.forgotPasswordSubscription?.unsubscribe();
    //this.accountLockedSubscription?.unsubscribe();
  }

  get emailAddressControl() {
    return this.loginForm.get('emailAddress') as FormControl;
  }

  get passwordControl() {
    return this.loginForm.get('password') as FormControl;
  }

  get caseIDControl() {
    return this.loginForm.get('caseID') as FormControl;
  }

  async forgotPasswordSubmit() {
    // Trigger API call for forgot password with New password & Confirm password
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = 'ForgotPassword';
    // Call API call to change password
    const data: PostRequestBase = Object.assign(
      screenModel.getDefaultPostRequest(),
    );

    try {
    
      await this.appUtility.logout({});
    } catch (ex) {
      // Uncomment this line to show error modal
      this.globals.showErrorModal(ex.message);
    }
  }

   async openForgetPasswordModal() {
    this.forgotPasswordModal = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
    });

    this.forgotPasswordModal.componentInstance.title = 'Forgot password';
    this.forgotPasswordModal.componentInstance.content =
      'Please log in again with the new password sent to your email address.';
    this.forgotPasswordModal.componentInstance.buttonText = 'Okay';
    this.forgotPasswordModal.componentInstance.showCloseCTA = false;
 
    // const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    // screenModel.screenName = 'ForgotPassword';
    // screenModel.productDetailResponse = await screenModel.callMiscServiceNoSession(this.pageID_forgotPassword,{'Type': 'ForgotPassword'})

    this.forgotPasswordSubscription =
      this.forgotPasswordModal.componentInstance.handleOnClickBtn.subscribe(
        async () => {
          await this.forgotPasswordSubmit();
        },
      );
  }

  async onSubmit() {
    // this.appUtility.login();
    await this.getBVDetailsService();
    this.isLoginFormSubmitted = true;
    this.isLoginFailed = false;

    if (this.loginForm.invalid) {
      return;
    }

    // Trigger API call for login with Email & Password
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = 'Login';
    
     const serviceBody:RequestServiceBodyGetOTP = {
        EmailAddress: this.emailAddressControl.value,
        Password:this.getPasswordHash(this.passwordControl.value), //ENABLE FOR DEV
        LoginMethod : "Email"
    }
    
   
    let uniqueLink = this.getPasswordHash(this.caseIDControl.value.toUpperCase())
    window.localStorage.setItem('digital-fna-unique-link',uniqueLink)
    // Call API to submit OTP & token
    const data: RequestData = Object.assign(
      screenModel.getDefaultPostRequest(),
      {
        ServiceBody :serviceBody
      },
    );
    const newData :RequestData = Object.assign({},data,{ServiceHeader : {
      ...data.ServiceHeader,
      PageName : this.pageName,
      RequestID : this.pageID_getOTPTimeout
    }})
  //   this.sharedAPIService.getOTPTimeOut(newData).subscribe((response: any) => {

  //     console.log("suTABtest");
  //     console.log(response);
   

  // })
    console.log(newData)
    const { ServiceBody: responseServiceBody, ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } =
      await this.apiService.read(newData);

    // On Success, return maskedMobileNumber & token/id/identifier(?)
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      console.log((responseServiceBody as ResponseServiceBodyGetOTP).OTPDelayTime);
      localStorage.setItem('DFNA-tokenID',responseServiceHeader['TokenID'])
      // Clear login form to default state
      const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
      screenModel.screenName = 'Login';
      this.isLoginFormSubmitted = false;
     // screenModel.productDetailResponse = await screenModel.callMiscService(this.pageID_productDetails,{})
     // this.sharedAPIService.storeProductDetailsToSS(screenModel.productDetailResponse)
      this.passwordControl.setValue('');
      // Open SMS OTP Modal
      this.openOtpModal(SmsOtpVerificationComponent);
    }

    // On Failure
    else {
      // Display error state

      if(responseServiceMessage && responseServiceMessage.ErrorDescription){
        this.login_fail_message = responseServiceMessage.ErrorDescription
      }
      this.isLoginFailed = true;
    }

    // this.router.navigateByUrl('/fna');
  }

  openOtpModal(content: any) {
    this.smsOtpModal = this.modalService.open(content, {
      backdrop: 'static',
      centered: true,
      keyboard: false,
    });
    // modalRef.componentInstance.onOTPSubmit = this.onOTPSubmit;
    this.otpSubmitSubscription =
      this.smsOtpModal.componentInstance.handleOTPSubmit.subscribe(
        (otp: string) => {
         
          console.log('[LoginComponent] CHECK: ', otp);
          this.handleOTPSubmit('dummyNumber', otp);
        },
      );

    this.otpResendSubscription =
      this.smsOtpModal.componentInstance.handleOTPResend.subscribe(() => {
        // TODO: Need backend to confirm what data is needed for OTP resend
        const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
        screenModel.screenName = 'Login';

        const data: RequestData = Object.assign(
          screenModel.getDefaultPostRequest(),
          {
            ServiceBody :{}
          },
        );
        const newData :RequestData = Object.assign({},data,{ServiceHeader : {
          ...data.ServiceHeader,
          PageName : this.pageName,
          RequestID : this.pageID_resendOTP,
          TokenID : this.apiService.getTokenID()
        }})
        this.apiService.read(newData).then((response) => {
          const { ServiceHeader: responseServiceHeader } =response;
          if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
            localStorage.setItem('DFNA-tokenID',responseServiceHeader['TokenID'])
            if (this.smsOtpModal?.componentInstance) {
              console.log('Resetting OTP expire');
              this.smsOtpModal.componentInstance.otpExpire = false;
            }
          } else {
            // TODO: Do we need to handle cases where OTP resend request is unsuccessful
            if (this.smsOtpModal?.componentInstance) {
              console.log('Resetting OTP expire');
              this.smsOtpModal.componentInstance.otpExpire = false;
            }
          }
        });
      });
  }

  async handleClickOCBCVelocityLogIn() {
    //@Integration: Implement Velocity log in handler

    await this.getBVDetailsService();

    let uniqueLink = this.getPasswordHash((this.loginFormBV.get('caseID') as FormControl).value.toUpperCase());
    window.localStorage.setItem('digital-fna-unique-link',uniqueLink)

    console.log('WEBURL',(this.loginFormBV.get('caseID') as FormControl).value)
  
    let bvRedirectURL = this.bv_login_URL+"?client_id="+this.bv_login_clientID+"&redirect_uri="+ window.location.origin + this.servlet_context_path + "&action=" + this.bv_action
   
    this.sharedAPIService.setRedirectionType('from_BV')
    window.location.replace(bvRedirectURL)
    console.log('[handleClickOCBCVelocityLogIn]');
  }

  handleClickCorppassLogIn() {
    //@Integration: Implement Corppass log in handler
    console.log('[handleClickCorppassLogIn]');
  }

  async handleOTPSubmit(token: string, otp: string) {
    console.log('[LoginComponent] OTP Success: ', otp);
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = 'OTP Submit';

    // Call API to submit OTP & token



    const serviceBody:RequestServiceBodyValidateOTP = {
      OTPCode : otp
  }
  // Call API to submit OTP & token
  const data: RequestData = Object.assign(
    screenModel.getDefaultPostRequest(),
    {
      ServiceBody :serviceBody
    },
  );

  let tokenID = localStorage.getItem('DFNA-tokenID');
  let extraChars = "\t{pr}"
  let finalTokenID =extraChars.concat(tokenID+"")
  const newData :RequestData = Object.assign({},data,{ServiceHeader : {
    ...data.ServiceHeader,
    PageName : this.pageName,
    RequestID : this.pageID_validateOTP,
    TokenID : finalTokenID
  }})



    // const data: LoginSMSOTPRequestData = Object.assign(
    //   screenModel.getDefaultPostRequest(),
    //   {
    //     Token: token,
    //     OTP: otp,
    //   },
    // );
   

    const { ServiceBody :serviceBodyRes,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } =
    await this.apiService.read(newData);
    // On Success
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
	    await this.appUtility.initializeAfterLogin();
      // Close modal and redirect to /fna/accredited-investor
      this.smsOtpModal?.close();
      
     
      if (serviceBodyRes && serviceBodyRes['LastSavedUIPage'] && serviceBodyRes['LastLoginDateTime'] && serviceBodyRes['LastLoginDateTime']!='' && serviceBodyRes['LastSavedUIPage']!='' ||  serviceBodyRes['FirstPasswordIndicator']) { //condition for last page opened
        let isFirstTimePassword = serviceBodyRes['FirstPasswordIndicator']
        this.lastSavedUIPage = serviceBodyRes['LastSavedUIPage'];
        if(isFirstTimePassword){
          this.openChangePasswordModal();
        }else{

          
          this.globals.updateModel({LastLoginTime: serviceBodyRes['LastLoginDateTime']})
          this.router.navigateByUrl(this.getRouteToURL(serviceBodyRes['LastSavedUIPage']));
        }
        
        
        //this.router.navigateByUrl('/fna/accredited-investor');
      } else {
        await this.router.navigateByUrl('/fna/accredited-investor');
      }
    }

    // On Failure
    else {
      // Handle error states
      if (this.smsOtpModal) {
        this.smsOtpModal.componentInstance.isError = true;
      }
    }
  }

  openChangePasswordModal() {
    this.changePasswordModal = this.modalService.open(ChangePasswordComponent, {
      size: 'lg',
      centered: true,
    });

    this.changePasswordSubmitSubscription =
      this.changePasswordModal.componentInstance.handleChangePasswordSubmit.subscribe(
        async (newPassword: string) => {
          await this.changePasswordSubmit(newPassword);
        },
      );
  }

  openForgotPasswordFormModal() {
    this.forgotPasswordModal = this.modalService.open(ForgotPasswordComponent, {
      size: 'lg',
      centered: true,
    });

    this.changePasswordSubmitSubscription =
      this.forgotPasswordModal.componentInstance.handleChangePasswordSubmit.subscribe(
        async (forgotPassString: string) => {
          console.log('TEST FORGOT  PASS');
          console.log(forgotPassString)
          
          await this.forgotPasswordInitialSubmit(forgotPassString);
        },
      );
  }
  
  async forgotPasswordInitialSubmit(forgotPassString: string) {
   

    try {
      let forgetPasswordObj = JSON.parse(forgotPassString);
      let caseID = this.getPasswordHash(forgetPasswordObj.caseID.toUpperCase());
      window.localStorage.setItem('digital-fna-unique-link',caseID)
      const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
      screenModel.screenName = 'ForgotPassword';
      screenModel.productDetailResponse = await screenModel.callMiscServiceNoSessionFP(this.pageID_forgotPassword,{'Type': 'ForgotPassword','EmailAddress':forgetPasswordObj.emailID})
      // Close modal and redirect to /fna/accredited-investor

      if(screenModel.productDetailResponse){
        this.forgotPasswordModal?.close();
        this.openForgetPasswordModal();

     
        
      }
      
    } catch (ex) {
      // Uncomment this line to show error modal
      this.globals.showErrorModal(ex.message);
    }
  }

  async changePasswordSubmit(newPassword: string) {
    // Trigger API call for change password with New password & Confirm password
    const screenModel = new ScreenModel(this.globals, this.apiService, this.el);
    screenModel.screenName = 'ChangePassword';
    // Call API call to change password

    try {
      screenModel.productDetailResponse = await screenModel.callMiscService(this.pageID_forgotPassword,{'Type': 'ChangePassword','Password':this.getPasswordHash(newPassword)})


      // Close modal and redirect to /fna/accredited-investor

      if(screenModel.productDetailResponse){
        this.changePasswordModal?.close();

        if(this.lastSavedUIPage == "" || this.lastSavedUIPage == null || this.lastSavedUIPage == undefined){
          await this.router.navigateByUrl('/fna/accredited-investor');
        }else{
          await this.router.navigateByUrl(this.getRouteToURL(this.lastSavedUIPage));
        }
        
      }
      
    } catch (ex) {
      // Uncomment this line to show error modal
      this.globals.showErrorModal(ex.message);
    }
  }


  fillFormWithMockData() {
    this.emailAddressControl.setValue('test@test.com');
    this.passwordControl.setValue('test123!!');
  }
}
